import React, { useEffect, useState } from 'react'
import {
  Box,
  chakra,
  Flex,
  FlexProps,
  Text,
  useColorMode,
  useDisclosure,
} from '@chakra-ui/react'

import { useAnimation, motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import CustomImage from '../Image'
import CustomButton from '../Button'
import {
  lightBgStep,
  sidePanelThemeColor,
} from '@/lib/constants/colorConstants'
import HelpModal from '../Help/HelpModal'
import { leftVarients, rightVarients } from '@/lib/animations'
import AccordionComponent from '../home/faq/AccordionComponent'

const FAQS = [
  {
    id: 1,
    title: 'What is a partner program?',
    description: `A partner is our affiliate and referral program that allows you to get paid by TestNotion.`,
  },

  {
    id: 2,
    title: 'How do I get paid?',
    description: `Payments are made through the payment section dashboard on your partner account.`,
  },
  {
    id: 3,
    title: 'Can I convert my commission to unit?  ',
    description: `No, you cannot. Affiliate commissions cannot be converted to units.`,
  },
  {
    id: 4,
    title: 'What commission do I get on each referral?  ',
    description: 'Up to 50% commission on each successful referral. ',
  },
  {
    id: 5,
    title: 'When do I get paid? ',
    description:
      'Payments are made instantly once referrals are successfully confirmed',
  },
  {
    id: 6,
    title: 'Who can I refer to TestNotion? ',
    description:
      'Admins, schools, and organisations looking to carry out online tests and exams ',
  },
  {
    id: 7,
    title: 'How mant times can I get paid from 1 referral?',
    description: '........',
  },
]

export default function FAQ(props: FlexProps) {
  const { colorMode } = useColorMode()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const controls = useAnimation()
  const { inView, ref } = useInView()

  useEffect(() => {
    if (inView) {
      controls.start('visible')
    }
  }, [controls, inView])

  const [help, setHelp] = useState<any>(false)

  const handleHelpModal = () => {
    setHelp(true)
    onOpen()
  }

  return (
    <chakra.section
      w="full"
      pb="6.25rem"
      pt="6.25rem"
      {...props}
      bg={lightBgStep[colorMode]}
      id="faq"
      overflowX={'hidden'}
      mx="auto"
    >
      <Box
        maxW="full"
        as={motion.div}
        animate={controls}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        p="0.8rem"
        mx="auto"
      >
        <Flex
          padding={['0 1rem', '0 6rem']}
          maxW="container.xl"
          columnGap={[2, 4, 6, 14]}
          rowGap={10}
          justifyContent="space-between"
          flexDir={['column', 'row']}
          alignItems={['', 'center']}
          mx="auto"
        >
          <CustomImage
            width={418}
            height={378}
            fill
            src="/faq__1_-removebg-preview 1.svg"
            flex={1}
            as={motion.div}
            variants={leftVarients}
          />
          <Box flex={2} as={motion.div} variants={rightVarients}>
            {FAQS &&
              FAQS.length > 0 &&
              FAQS.map(data => (
                <AccordionComponent
                  key={data.id}
                  title={data.title}
                  description={data.description}
                />
              ))}
          </Box>
        </Flex>
        <Text
          textAlign="center"
          fontSize={['1rem', '1.5rem']}
          fontWeight="medium"
          mb="3rem"
          mt="4rem"
        >
          Did not get what you are looking for?
        </Text>
        <Box textAlign="center">
          <CustomButton
            maxW="12rem"
            maxH="3rem"
            fontWeight="medium"
            borderRadius={'5px'}
            onClick={handleHelpModal}
            fontSize={{ base: '0.8rem', md: '1rem' }}
          >
            Get Help
          </CustomButton>
          {help && (
            <HelpModal isOpen={isOpen} onClose={onClose} onClick={onClose} />
          )}
        </Box>
      </Box>
    </chakra.section>
  )
}
